<template>
  <div>
    <div class="relative mx-4 my-2">
      <span v-if='debouncedApolloLoading' class="apollo-spinner text-green-500" />
      <magnify v-else :size='32' class="apollo-search left-0 " />
      <input type="search" class="w-full m-1 bg-purple-white shadow rounded border-0 p-3 pl-10" placeholder="Search images..." v-model='search' >
    </div>

    <scrolling-image-gallery :images='images' :load-more='loadMore' v-on='$listeners' />

  </div>
</template>
<script>
import { uniqBy } from 'lodash';
import Magnify from '@icons/Magnify.vue';
import Loading from '@ui/atoms/Loading.vue';
import { listImagesQuery } from '@/gql/Queries.js';
import ScrollingImageGallery from './ScrollingImageGallery.vue';

const pageSize = 10

export default {
  inject: ['api'],
  props: {
    gameId: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      search:'',
      from: 0,
      size: 50,
      debouncedApolloLoading: false,
      nextToken:'',
      getImages: {
        items: [],
        nextToken: ''
      }
    }
  },
  apollo: {
    // Pages
    getImages: {
      // GraphQL Query
      query: listImagesQuery,
      // Initial variables
      variables() {
        return {
          nextToken: '',
          size: this.size,
          search: this.apolloSearchString
        }
      }
    },
  },
  methods: {
    async loadMore() {
      //this.page++
      // Fetch more data and transform the original result
      const lengthBefore = this.getImages.items.length;
      try {
        const result = await this.$apollo.queries.getImages.fetchMore({
          // Transform the previous result with new data
          fetchPolicy: 'cache-and-network',
          variables: {
            nextToken: this.nextToken,
            search: this.apolloSearchString,
            size: this.size
          },
          updateQuery: (previousResult, { fetchMoreResult }) => {
            const {getImages} = fetchMoreResult;
            const newItems = getImages.items;
            const total = getImages.total;

            const items = uniqBy([...previousResult.getImages.items, ...newItems], ({id}) => {
              return id;
            });
            this.nextToken = getImages.nextToken;
            return {
              getImages: {
                __typename: previousResult.getImages.__typename,
                // Merging the tag list
                items,
                nextToken: this.nextToken
              },
            }
          },
        })
        const currentLength = lengthBefore + result.data.getImages.items.length;
        const total = result.data.getImages.total;
        return total - currentLength;
      } catch (e) {
        console.error('error running graphql', e);
        return 0;
      }
    },
  },
  components: {
    ScrollingImageGallery,
    Magnify,
  },
  computed:{
    images() {
      return this.getImages.items.map( (img) => {
        img.url = this.api.makeImageUrlEditor(img.id);
        return img;
      });
    },
    apolloSearchString() {
      if (this.search && this.search.length) {
        return this.search;
      }
      return undefined;
    }
  },
  watch: {
    search() {
      this.from = 0;
    },
    '$apollo.loading'(nv) {
      if (!nv) {
        clearTimeout(this._debouncedApolloInterval);
        this._debouncedApolloInterval = null;
        this.debouncedApolloLoading = false;
      } else {
        clearTimeout(this._debouncedApolloInterval);
        this._debouncedApolloInterval = setTimeout( () => {
          this.debouncedApolloLoading = true;
          this._debouncedApolloInterval = null;
        }, 600);
      }
    }
  }
}
</script>
